export const linearInterpolate = (
    inputValue: number,
    inputMin: number,
    inputMax: number,
    outputMin: number,
    outputMax: number,
    skipMaxThreshold = false,
    ratio = 1,
): number => {
    if (inputValue <= inputMin) {
        return outputMin * ratio;
    }

    if (!skipMaxThreshold && inputValue >= inputMax) {
        return outputMax * ratio;
    }

    // Calculate interpolation factor (t) between 0 and 1
    const t = (inputValue - inputMin) / (inputMax - inputMin);

    // Linear interpolation
    return (outputMin + (outputMax - outputMin) * t) * ratio;
};
